import type { AxiosError } from 'axios';
import axiosInstance from '@/services/interceptor.services';

export const StoreSettingsService = {
  /**
   * Récupère les paramètres (settings) d'un commerce, groupés par catégorie.
   */
  getStoreSettings: async (storeId: string) => {
    try {
      const response = await axiosInstance.get(
        `restaurants/${storeId}/settings`,
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },

  /**
   * Récupère le thème résolu (couleurs light/dark, enabled, preset) d'un
   * commerce, avec héritage déjà appliqué module → commerce → preset.
   */
  getStoreTheme: async (storeId: string) => {
    try {
      const response = await axiosInstance.get(
        `restaurants/${storeId}/settings/theme`,
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },

  /**
   * Met à jour un ou plusieurs paramètres d'un commerce (fusion partielle).
   */
  updateStoreSettings: async (
    storeId: string,
    values: Record<string, unknown>,
    generateDark?: boolean,
  ) => {
    try {
      const response = await axiosInstance.put(
        `restaurants/${storeId}/settings`,
        {
          values,
          ...(generateDark != null ? { generateDark } : {}),
        },
      );
      return response;
    } catch (error) {
      const err = error as AxiosError;
      return Promise.reject(err);
    }
  },
};
